import { IS_BIZ_USER, IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { features } from 'reactApp/mail-features';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';

const constraints = !IS_BIZ_USER && !IS_ONPREMISE;

/* Информер о сейфе в Корзине */
// показывать информер о сейфе вместо обычного оверквотного в Корзине
export const trashbinSafeInformer: boolean = constraints && features.has('trashbin-safe-informer');
// показывать информер о сейфе, только если в сейфе реально что-то есть
export const safeCheckIsEmpty: boolean = trashbinSafeInformer && features.has('safe-check-is-empty');

/* Кнопка перемещения в сейф в Корзине */
// заменить кнопку удаления в Корзине на перемещение в сейф
export const trashbinMoveToSafeButton: boolean = constraints && features.has('trashbin-move-to-safe-button');
// тултипы на кнопке перемещения в сейф
export const overquotaSafeTip: boolean = trashbinMoveToSafeButton && features.has('overquota-safe-tip');
export const overquotaSafeTipEveryDay: boolean = constraints && features.has('overquota-safe-tip-everay-day');

export const helpSafeHref = features.getAsString('safe-promo-help', 'https://help.mail.ru/cloud_web/size/safe/');

const tariffIds = {
    month: ['W256G1m_single_quota_2022_cloud', 'W512G1m_single_quota_2022_cloud', 'W1T1m_single_quota_2022_cloud'],
    year: ['W256G1y_single_quota_2022_cloud', 'W512G1y_single_quota_2022_cloud', 'W1T1y_single_quota_2022_cloud'],
};

export const overquotaSafeTariffIds: YearAndMonthProductIds = features.getAsJSON('overquota-safe-tariffs', tariffIds);
